"use client";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  // FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { z } from "zod";
import useForgotPassword from "@/features/authentication/hooks/useForgotPassword";
import RefreshIcon from "@/components/atoms/svg/icons/RefreshIcon";
import clsx from "clsx";
const formSchema = z.object({
  email: z.string().email(),
});

export type FormForgotPasswordValues = z.infer<typeof formSchema>;

interface FormForgotPasswordProps {
  initailData: FormForgotPasswordValues;
}

const FormForgotPassword: React.FC<FormForgotPasswordProps> = ({
  initailData,
}) => {
  const router = useRouter();
  const form = useForm<FormForgotPasswordValues>({
    mode: "onChange",
    resolver: zodResolver(formSchema),
    defaultValues: initailData || { email: "" },
  });

  const { onSubmit, isDisabledSubmit } = useForgotPassword();

  return (
    <div id="form-forgot-password--wrapper">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                {/* <FormLabel>Email</FormLabel> */}
                <FormControl>
                  <Input
                    className="base-input"
                    placeholder="Email"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="flex flex-col items-center pt-4 pb-2 gap-4 text-center">
            <Button
              disabled={!form.formState.isValid || isDisabledSubmit}
              className={clsx(
                "btn-purple rounded-full w-full",
                isDisabledSubmit &&
                  "flex items-center justify-center gap-4 btn-large/40",
              )}
              type="submit"
            >
              Submit
              {isDisabledSubmit && (
                <RefreshIcon className="animate-spin" fillOpacity={0.6} />
              )}
            </Button>
            <Button
              onClick={router.back}
              variant="outline"
              className="rounded-full w-full"
              type="button"
            >
              Back
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
};

export default FormForgotPassword;
